module.exports = __webpack_public_path__ + "static/media/signup-illustration.527babdb.svg";